export const filterMaterialsHelper = ({
  options = [],
  type = "materials",
  showOnlyGroup = false,
  previousItems = [],
}) => {
  let filteredList = options[type] || options?.materials || [];

  if (showOnlyGroup) {
    filteredList = filteredList.filter(
      (item) => item.category === showOnlyGroup
    );
  }

  // filter out materials with lower sortOrder than previously selected
  if (previousItems?.length) {
    const maxPrevSortOrder = Math.max(
      ...previousItems.map(
        (id) => filteredList.find((m) => m.id === id)?.sortOrder || 0
      )
    );
    filteredList = filteredList.filter(
      (item) => !item.sortOrder || item.sortOrder >= maxPrevSortOrder
    );
  }

  // sort by material's sortOrder if available
  return [...filteredList].sort((a, b) =>
    !a.sortOrder ? 1 : !b.sortOrder ? -1 : a.sortOrder - b.sortOrder
  );
};

export const filterFnc = ({ customFilter, departmentId }) =>
  customFilter
    ? (o) => customFilter(o)
    : (o) => {
        const departmentMatch = departmentId
          ? o.departmentId === departmentId
          : true;
        return departmentMatch;
      };
